import { createContext, useContext } from 'react'

interface AdminMenuContextValue {
  onOpenMenu?: () => void
  isMenuOpen?: boolean
}

// Keep this context local to admin chrome. If admin UI state grows enough to
// need Zustand, replace this context instead of layering a store on top of it.
export const AdminMenuContext = createContext<AdminMenuContextValue>({})

export function useAdminMenu() {
  return useContext(AdminMenuContext)
}
